export { default } from './TipModal';
